import {
	DATA_TABLE_SECTION_I18N_KEYS
} from '../../../../../features/topics/components/constants/i18n/DataTableSectioni18nConstants';

export const DATA_TABLE_SECTION_I18N_EN = {
	[DATA_TABLE_SECTION_I18N_KEYS.number_of_rows_displayed]: "First 100 rows displayed"
};


// WEBPACK FOOTER //
// ./src/locales/en/features/topics/components/data_table_section.i18n.en.js